import { regexNumber, regexPhone } from '@/utils/utils';
import { TextField, SxProps, Theme } from '@mui/material';
import React from 'react';

interface BookingFormInputProps {
  sx?: SxProps<Theme>;
  register?: any;
  [key: string]: any;
}

const BookingFormInput: React.FC<BookingFormInputProps> = ({ sx = {}, ...props }) => {
  const { register, onChange, onBlur, ...otherProps } = props;

  const onKeyPress = (e: any) => {
    if (props.type === 'number' && !(e.key <= 9 && e.key >= 0)) {
      e.preventDefault();
    }

    if (props.type === 'tel' && !(e.key <= 9 && e.key >= 0) && e.key !== '+') {
      e.preventDefault();
    }
  };

  const onPaste = (e: any) => {
    const text = e.clipboardData.getData('text/plain').replaceAll(' ', '');
    if (props.type === 'number' && !regexNumber.test(text)) {
      e.preventDefault();
    }

    if (props.type === 'tel' && !regexPhone.test(text)) {
      e.preventDefault();
    }
  };

  return (<TextField
    {...register}
    {...otherProps}
    onChange={(e: any) => {
      onChange && onChange(e);
      register?.onChange(e);
    }}
    onBlur={(e: any) => {
      onBlur && onBlur(e);
      register?.onBlur(e);
    }}
    onKeyPress={onKeyPress}
    onPaste={onPaste}
    onWheel={(e: any) => e.target.blur()}
    variant="filled"
    sx={{
      borderRadius: 2,
      background: 'transparent',
      fontSize: 14,
      minHeight: 48,
      '& .MuiFilledInput-root': {
        borderRadius: 2,
        background: 'transparent',
        fontSize: 15,
        minHeight: 56,

        '&.Mui-focused': {
          backgroundColor: 'transparent',
        },
      },
      ...sx,
      ":hover": {
        backgroundColor: "transparent",
      },
      ":active": {
        backgroundColor: "transparent",
      }
    }}
  />
  );
}

export default BookingFormInput; 